import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "../components/Modal";
import { useInstallPrompt } from "./installPrompt";
import Ic from "../components/icons.jsx";

/**
 * "Instaliraj aplikaciju" at the bottom of the side navigation. Shown only while the
 * page is not already installed: Chrome/Edge/Samsung get the native prompt, iOS Safari
 * gets the manual steps (Share → Add to Home Screen). Nothing on browsers that cannot install.
 */
export function InstallAppNavItem({ tip }: { tip?: boolean }) {
  const { t } = useTranslation();
  const state = useInstallPrompt();
  const [iosHelp, setIosHelp] = useState(false);
  if (state.kind === "none") return null;
  const label = t("pwa.install", "Instaliraj aplikaciju");
  return (
    <>
      <div className="nav-section">{t("pwa.section", "Telefon / tablet")}</div>
      <button
        type="button"
        className="nav-item nav-item-btn"
        data-tip={tip ? label : undefined}
        onClick={() => { if (state.kind === "prompt") void state.install(); else setIosHelp(true); }}
      >
        <Ic.download />
        <span style={{ flex: 1 }}>{label}</span>
      </button>
      {iosHelp && (
        <Modal title={label} subtitle={t("pwa.iosSub", "Na iPhone-u i iPad-u aplikacija se dodaje kroz Safari.")} onClose={() => setIosHelp(false)} width={440}>
          <ol className="pwa-ios-steps">
            <li>{t("pwa.ios1", "Dodirnite dugme Deli (kvadrat sa strelicom) na dnu Safarija.")}</li>
            <li>{t("pwa.ios2", "Izaberite „Dodaj na početni ekran“ (Add to Home Screen).")}</li>
            <li>{t("pwa.ios3", "Potvrdite sa „Dodaj“ — ikonica Bankom CMMS se pojavljuje na početnom ekranu.")}</li>
          </ol>
          <div className="form-actions">
            <button type="button" className="btn primary" onClick={() => setIosHelp(false)}>{t("action.ok", "U redu")}</button>
          </div>
        </Modal>
      )}
    </>
  );
}
